import { Injectable, } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BaseServiceService } from '../base-service/base-service.service';
import { USERS } from '../../app.constants'
import { MASTER } from '../../app.constants'
import { getBodyNode } from '@angular/animations/browser/src/render/shared';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends BaseServiceService {

  constructor(http: HttpClient) {
    super(http)
  }

  auth(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.AUTH, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  authenticateV2(userAdd) {
    return new Promise((resolve, reject) => {
      try {
        let apiName = 'api/users/v2/auth';
        this.postCall(apiName, userAdd).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  changeInternalUserPassword(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.CHANGE_INTERNAL_USER_PASSWORD, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  resetInternalUserPassword(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.RESET_INTERNAL_USER_PASSWORD, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  updateProfile(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.UPDATE_PROFILE, reqObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  viewProfile(userType) {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.VIEW_PROFILE + userType).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  updateUserDetails(userType) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.UPDATE_USER, userType).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  // UPDATE_INTERNAL_USER
  updateInternalUser(userType) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.UPDATE_INTERNAL_USER, userType).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  activateInternalUser(body) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.ACTIVATE_INTERNAL_USER + body.id, { status: body.status }).subscribe((data) => {
          if (data != null) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  updatePassword(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.UPDATE_PASSWORD, reqObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  resetPassword(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.RESET_PASSWORD, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  randomGeneratorPassword(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.RONDOM_PASSWORD, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  resetPasswordWithOtp(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.RESET_PASSWORD_WITH_OTP, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  searchUser(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.SEARCH_INTERNAL_USER, requestObj).subscribe((data) => {
          // this.postCall(USERS.SEARCH_USER, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  searchUserCentral(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.SEARCH_USER, requestObj).subscribe((data) => {
          // this.postCall(USERS.SEARCH_USER, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  searchUserForExtension(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.SEARCH_USER_FOR_EXTENSION, requestObj).subscribe((data) => {
          // this.postCall(USERS.SEARCH_USER, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  searchUserV2(requestObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.SEARCH_USER_V2, requestObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  forgotPassword(userAdd) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.FORGOT_PASSWORD, userAdd).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  registerInternalUser(reqInfo) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.REGISTER_INTERNAL_USER, reqInfo).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  // GET_MENU_LIST
  getMenuList() {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.GET_MENU_LIST).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  // GET_USER_RIGHTS
  getUserRights(userId) {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.GET_USER_RIGHTS + userId).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  // api/users/updateUser
  updateUser(userId) {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.GET_USER_RIGHTS + userId).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  createUserRights(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.CREATE_USER_RIGHTS, reqObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  updateUserRights(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.UPDATE_USER_RIGHTS, reqObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  updateUserTypeRight(reqObj) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.UPDATE_USER_TYPE_RIGHT, reqObj).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.LOGOUT).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  getCaptcha() {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.GET_CAPTCHA).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  verifyCaptcha(body) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.VERIFY_CAPTCHA, body).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  getDomainAndProductDetails(userId) {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.GET_DOMAIN_AND_PRODUCT_DETAILS + userId).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  deleteDomain(id) {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.DELETE_DOMAIN + id).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  updateDetailsDLTMLT(userType) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.UPDATE_INTERNAL_USER_MT_DLT, userType).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }


  updateDetailsIncu(userType) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(USERS.UPDATE_INCUBATION_NEW, userType).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  searchInternalUser(searchValue) {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(USERS.SEARCH_INTERNAL_USERS + '/' + searchValue).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  getAllMasterMainMenu() {
    return new Promise((resolve, reject) => {
      try {
        this.getCall(MASTER.GET_MAIN_MENU ).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  getsubMenu(body) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(MASTER.GET_SUB_MENU ,body).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  saveMainMenu(body) {
    return new Promise((resolve, reject) => {
      try {
        this.postCall(MASTER.SAVE_MENU ,body).subscribe((data) => {
          if (data != null && data != undefined) {
            resolve(data);
          } else {
            reject();
          }
        }, (error) => {
          reject(error);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

}

